import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  CreateReturnedClientsFilterViewParams,
  CreateReturnedClientsFilterViewResponse,
  MutationResponse,
} from '@/types/api/mutations';

import { RETURNED_CLIENTS_FILTER_VIEWS_LIST_QUERY_KEY } from '@/queries/returnedClientsFilterViews';

import { HttpClient } from '@/network/HttpClient';

export const useCreateReturnedClientsFilterViewMutation = () =>
  useMutation({
    mutationFn: (params: CreateReturnedClientsFilterViewParams) =>
      HttpClient.request<CreateReturnedClientsFilterViewResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useDeleteReturnedClientsFilterViewMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request<MutationResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [RETURNED_CLIENTS_FILTER_VIEWS_LIST_QUERY_KEY],
      });
    },
  });
};
